'use client';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

// A block of paragraph placeholder lines with varied widths — the body copy
// shared by the about overview and any simple content page.
const DEFAULT_WIDTHS = ['100%', '97%', '92%', '99%', '85%', '70%'];

export function TextLinesSkeleton({widths = DEFAULT_WIDTHS}: {widths?: string[]}) {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
      {widths.map((w, i) => (
        <Skeleton key={i} variant="text" animation="wave" width={w} />
      ))}
    </Box>
  );
}

TextLinesSkeleton.displayName = 'TextLinesSkeleton';
